import moment from 'moment';

export const formatStatus = (statusStr: string | null | undefined) => {
    return statusStr?.toLowerCase().replaceAll('_', ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
}

export const formatDate = (date: Date | null | undefined) => {
    if (!date) {
        return null;
    }
    return moment(date).format("YYYY-MM-DD");
}
export const formatBirthDate = (date: Date | null) => {
    if (!date) {
        return null;
    }
    return moment(date).format("MM/DD/YYYY");
}

export const formatDatetime = (date: Date | null | undefined) => {
    if (!date) {
        return null;
    }
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
}

export const formatPhone = (phoneStr: string | null | undefined) => {
    if (!phoneStr) {
        return null;
    }
    if (phoneStr.length != 10) {
        return phoneStr;
    }
    return '(' + phoneStr.slice(0, 3) + ') ' + phoneStr.slice(3, 6) + '-' + phoneStr.slice(6, 10);
}

export const convertMinutesToReadableTime = (minutes: number): string => {
    if (minutes < 0) {
        return "";
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const hoursPart = hours === 1 ? `${hours}h` : `${hours}h`;
    const minutesPart = remainingMinutes === 1 ? `${remainingMinutes}m` : `${remainingMinutes}m`;

    if (hours > 0 && remainingMinutes > 0) {
        return `${hoursPart} ${minutesPart}`;
    } else if (hours > 0) {
        return hoursPart;
    } else {
        return minutesPart;
    }
}
